'use client';

import { useSyncExternalStore } from 'react';

import { createNotificationStore } from '../stores/notification-store';

interface UseNotificationCountOptions {
  token: string | undefined;
}

export const useNotificationCount = (options: UseNotificationCountOptions) => {
  const store = createNotificationStore(options.token ?? '');

  const data = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getServerSnapshot,
  );

  return {
    notifications: data?.notifications,
    chatMessages: data?.chatMessages,
  };
};
